
import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { AppStoreSearch } from "./AppStoreSearch";
import { ABMAppsSelect } from "./ABMAppsSelect";
import { AppStoreSearchResult, ABMApp } from "@/types/application";
import { Store, Building2 } from "lucide-react";

export type SelectedApp = 
  | { type: 'appStore'; app: AppStoreSearchResult }
  | { type: 'abm'; app: ABMApp };

interface ApplicationCatalogProps {
  onSelectApp: (selection: SelectedApp) => void;
  selectedAppId?: string;
}

export const ApplicationCatalog = ({ onSelectApp, selectedAppId }: ApplicationCatalogProps) => {
  const [activeTab, setActiveTab] = useState("appStore");

  const handleAppStoreSelect = (app: AppStoreSearchResult) => {
    onSelectApp({ type: 'appStore', app });
  };

  const handleABMSelect = (app: ABMApp) => {
    onSelectApp({ type: 'abm', app });
  };

  return (
    <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
      <TabsList className="grid w-full grid-cols-2">
        <TabsTrigger value="appStore" className="flex items-center gap-2">
          <Store className="h-4 w-4" />
          App Store
        </TabsTrigger>
        <TabsTrigger value="abm" className="flex items-center gap-2">
          <Building2 className="h-4 w-4" />
          Apps & Books (ABM)
        </TabsTrigger>
      </TabsList>
      <TabsContent value="appStore" className="mt-4">
        <AppStoreSearch onSelectApp={handleAppStoreSelect} selectedAppId={selectedAppId} />
      </TabsContent>
      <TabsContent value="abm" className="mt-4">
        <ABMAppsSelect onSelectApp={handleABMSelect} selectedAppId={selectedAppId} />
      </TabsContent>
    </Tabs>
  );
};
